/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
export const HappyFaceSmallIcon = ({size, ...props}) => (
  <svg viewBox="0 0 14 14" fill="currentColor" width={ size || "14" } height={ size || "14" } {...props}>
    <path d="M7 14c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7-3.134 7-7 7zm0-1c3.314 0 6-2.686 6-6s-2.686-6-6-6-6 2.686-6 6 2.686 6 6 6zm2.885-4.174C9.526 10.081 8.37 11 7 11c-1.374 0-2.532-.924-2.888-2.184.478-.135 0 0 .964-.268C5.314 9.386 6.086 10 7 10c.915 0 1.687-.615 1.924-1.454.337.1 0 .002.96.28zM5 5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm4 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
      fillRule="evenodd" />
  </svg>
);
HappyFaceSmallIcon.displayName = 'HappyFaceSmallIcon';
HappyFaceSmallIcon.propTypes = {
  size: PropTypes.string
}
/* tslint:enable */
/* eslint-enable */
